import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { PROJECT_EMAIL_LOCAL_API_REQUESTS } from './utils/constants';

export const getUnreadMessagesCount = async () => {
  const apiPath = `project-email/get-unread-messages-count`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    isLocalApiRequest: PROJECT_EMAIL_LOCAL_API_REQUESTS,
  });

  const response = await axios(signedRequest);

  return response.data;
};
